export default __webpack_public_path__ + "static/media/Van18.5f890d71.webp";